import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { CitizensServicesGroups } from './citizens-services-groups.model';

export const loadCitizensServicesGroupss = createAction(
  '[CitizensServicesGroups/API] Load CitizensServicesGroupss', 
  props<{ citizensServicesGroupss: CitizensServicesGroups[] }>()
);

export const addCitizensServicesGroups = createAction(
  '[CitizensServicesGroups/API] Add CitizensServicesGroups',
  props<{ citizensServicesGroups: CitizensServicesGroups }>()
);

export const upsertCitizensServicesGroups = createAction(
  '[CitizensServicesGroups/API] Upsert CitizensServicesGroups',
  props<{ citizensServicesGroups: CitizensServicesGroups }>()
);

export const addCitizensServicesGroupss = createAction(
  '[CitizensServicesGroups/API] Add CitizensServicesGroupss',
  props<{ citizensServicesGroupss: CitizensServicesGroups[] }>()
);

export const upsertCitizensServicesGroupss = createAction(
  '[CitizensServicesGroups/API] Upsert CitizensServicesGroupss',
  props<{ citizensServicesGroupss: CitizensServicesGroups[] }>()
);

export const updateCitizensServicesGroups = createAction(
  '[CitizensServicesGroups/API] Update CitizensServicesGroups',
  props<{ citizensServicesGroups: Update<CitizensServicesGroups> }>()
);

export const updateCitizensServicesGroupss = createAction(
  '[CitizensServicesGroups/API] Update CitizensServicesGroupss',
  props<{ citizensServicesGroupss: Update<CitizensServicesGroups>[] }>()
);

export const deleteCitizensServicesGroups = createAction(
  '[CitizensServicesGroups/API] Delete CitizensServicesGroups',
  props<{ id: string }>()
);

export const deleteCitizensServicesGroupss = createAction(
  '[CitizensServicesGroups/API] Delete CitizensServicesGroupss',
  props<{ ids: string[] }>()
);

export const clearCitizensServicesGroupss = createAction(
  '[CitizensServicesGroups/API] Clear CitizensServicesGroupss'
);


//customs

export const citizenGetServicesGroups = createAction(
  '[CitizensServicesGroups/API] citizen Get Services Groups',
  props<{ serviceUniqueId?: string }>()
);